import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { LearningOpportunitiesOptions } from '~/shared/data-contract/learning-opportunities';
import { learningOpportunitiesOptionsSchema } from '~/shared/data-contract/learning-opportunities';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

import { learningOpportunityKeys } from './query-keys';

const pathname: Pathname = `/learning-opportunities/options`;

export const useLearningOpportunitiesOptionsQuery = (): UseQueryResult<LearningOpportunitiesOptions> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(learningOpportunitiesOptionsSchema, {
                pathname,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: learningOpportunityKeys.options(),
        staleTime: 10_000,
        throwOnError: false,
    });
};
